export const CREATE_CARE_PROVIDER_FAILURE = 'CREATE_CARE_PROVIDER_FAILURE';

export const createCareProviderFailure = error => ({
    type: CREATE_CARE_PROVIDER_FAILURE,
    payload: error,
    error: true,
});
